import { Controller } from "@hotwired/stimulus";

// Toggles the wallet UI between the network's dark theme (wdark/dark/cdark) and
// the shared light theme (wlight). The choice is persisted in localStorage and
// re-applied before first paint by the inline script in base.html (no FOUC).
//
// Markup:
//   <button data-controller="theme-toggle" data-action="theme-toggle#toggle">
//     <span data-theme-toggle-target="dark">…moon…</span>
//     <span data-theme-toggle-target="light">…sun…</span>
//   </button>
const STORAGE_KEY = "waas-theme";
const DARK_THEMES = ["wdark", "dark", "cdark"];

export default class extends Controller {
  static targets = ["dark", "light"];

  connect() {
    this.syncIcons();
  }

  toggle() {
    const root = document.documentElement;
    if (this.isLight()) {
      this.applyDark(root);
      this.store("dark");
    } else {
      this.applyLight(root);
      this.store("light");
    }
    this.syncIcons();
    // Let theme-dependent controllers (e.g. background video) react.
    document.dispatchEvent(
      new CustomEvent("theme:changed", { detail: { light: this.isLight() } })
    );
  }

  isLight() {
    return document.documentElement.classList.contains("wlight");
  }

  networkDarkTheme() {
    const root = document.documentElement;
    return (
      root.getAttribute("data-dark-theme") ||
      DARK_THEMES.find((t) => root.classList.contains(t)) ||
      "wdark"
    );
  }

  applyLight(root) {
    DARK_THEMES.forEach((t) => root.classList.remove(t));
    root.classList.add("wlight");
  }

  applyDark(root) {
    root.classList.remove("wlight");
    root.classList.add(this.networkDarkTheme());
  }

  store(value) {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      /* storage unavailable — theme still applies for this session */
    }
  }

  // Show the icon representing the theme you'd switch TO.
  syncIcons() {
    const light = this.isLight();
    if (this.hasDarkTarget) this.darkTarget.classList.toggle("hidden", !light);
    if (this.hasLightTarget) this.lightTarget.classList.toggle("hidden", light);
  }
}
